var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-edit",staticStyle:{"max-width":"1000px","margin":"auto"}},[(_vm.fs)?_c('edit',{attrs:{"api":_vm.api,"fs":_vm.fs,"id":_vm.id,"back":"/admin/users","title":"user"},on:{"saved":_vm.saved}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }